import { LakeConfig } from "../data/lakeData";

const LIFETIME_SCORE_KEY = "spearfest.lifetimeScore";

export class ProgressionService {
    static getLifetimeScore(): number {
        const raw = window.localStorage.getItem(LIFETIME_SCORE_KEY);
        const parsed = Number(raw ?? 0);
        return Number.isFinite(parsed) ? Math.max(0, parsed) : 0;
    }

    static addLifetimeScore(amount: number): number {
        const current = this.getLifetimeScore();
        const next = current + Math.max(0, Math.floor(amount));
        window.localStorage.setItem(LIFETIME_SCORE_KEY, String(next));
        return next;
    }

    static isLakeUnlocked(lake: LakeConfig): boolean {
        return this.getLifetimeScore() >= lake.unlockLifetimeScore;
    }
}
